import theme from "@shared/utils/themeColors";
import React from "react";

interface ConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isLoading?: boolean;
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
}

export const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  isLoading = false,
  title,
  message,
  confirmText = "Confirm",
  cancelText = "Cancel",
}) => {
  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 bg-slate-900 bg-opacity-30 z-50 transition-opacity"
      style={{ marginTop: 0 }}
    >
      <div
        className="fixed inset-0 z-50 overflow-hidden flex items-center my-4 justify-center px-4 sm:px-6"
        style={{ marginTop: "0px !important" }}
      >
        <div className="bg-white dark:bg-slate-800 rounded shadow-lg w-full max-w-lg">
          <div className="p-6">
            <div className="mb-4">
              <h2 className="text-xl font-bold text-slate-800 dark:text-slate-100 mb-2">
                {title}
              </h2>
              <p className="text-sm text-slate-500 dark:text-slate-400">
                {message}
              </p>
            </div>
            <div className="flex flex-wrap justify-end space-x-2">
              <button
                className="btn-sm border-slate-200 dark:border-slate-700 hover:border-slate-300 dark:hover:border-slate-600 text-slate-600 dark:text-slate-300"
                onClick={onClose}
                disabled={isLoading}
              >
                {cancelText}
              </button>
              <button
                className={`btn-sm ${theme.bg.error} hover:bg-red-600 text-white`}
                onClick={onConfirm}
                disabled={isLoading}
              >
                {isLoading ? "Loading..." : confirmText}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
